import moment from 'moment';

const findClass = (classList, classId) => (classList || []).find((classData) => classData.classId === classId);

// classList only holds active classes, so a notification can point at a class that is not in it:
// a blank classId (NeetoCal meeting name missing from the webhook's class map) or a deactivated class.
export const getRowsWithUnknownClass = (rows, classList) => (rows || []).filter((data) => !findClass(classList, data.classId));

export const buildSalesNotificationCSVRows = (rows, classList) =>
  (rows || []).map((data) => {
    const matchedClass = findClass(classList, data.classId);
    return {
      userName: data.name && data.name,
      className: (matchedClass && matchedClass.name) || '',
      email: data.email,
      mobileNumber: data.mobile,
      startTime: data.startTime ? moment(data.startTime).format('ll hh:mm A') : '',
      timeZone: data.timezone,
      CreatedBy: data?.createdBy?.toLocaleUpperCase(),
      status: data?.notificationStatus || "",
      notes: data?.notes || "",
    };
  });
